<template>
  <div class="help">
    <div class="modal-background">
      <div class="modal-wrapper" :class="$mq">
        <div class="modal">
          <h1>{{ $t('Offer.Carousel.Help.title') }}
            <span class="close" @click="$emit('close')"></span>
          </h1>
          <div>
            <p class="inline left">
              <span class="question">{{ $t('Offer.Carousel.Help.dom') }}</span>
              <BecomeField class="switch" name="dom" type="switch" :possibleValues="possibleValues" v-model="dom" silent></BecomeField>
            </p>
          </div>
          <div v-if="dom !== null">
            <p class="inline left">
              <span class="question">{{ $t('Offer.Carousel.Help.fix') }}</span>
              <BecomeField class="switch" name="fix" type="switch" :possibleValues="possibleValues" :value="fix" @input="setFix" silent></BecomeField>
            </p>
          </div>
          <div v-if="fix !== null && fix !== 0">
            <p  class="inline left">
              <span class="question">{{ $t('Offer.Carousel.Help.longer') }}</span>
              <BecomeField class="switch" name="longer" type="switch" :possibleValues="possibleValues" :value="longer" @input="setLonger" silent></BecomeField>
            </p>
          </div>
          <div class="help-loader" v-if="longer !== null">
            <h2>{{ $t('Offer.Carousel.Help.loading') }}</h2>
            <SvgIcon class="loading" icon="loading"></SvgIcon>
          </div>
        </div>
        <button class="button main" @click="$emit('close')">{{ $t('back') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import BecomeField from '@/components/Form/BecomeField'

export default {
  data() {
    return {
      dom: null,
      fix: null,
      longer: null,
      possibleValues: [
        { label: this.$t('Offer.Carousel.Help.yes'), value: 1 },
        { label: this.$t('Offer.Carousel.Help.no'), value: 0 },
      ],
    }
  },
  methods: {
    async setFix(value) {
      this.fix = value;

      if(this.fix === 0) {
        this.setLonger(0);
      }
    },
    async setLonger(value) {
      this.longer = value;

      await this.completed()
    },
    async completed() {
      let result = [this.dom, this.fix, this.longer];
      this.$emit("completed", result);
      await this.sleep(800);
      this.$emit('close');
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  components: {
    BecomeField
  }
};
</script>

<style lang="scss" scoped>
  .active {
    font-weight: bold;
    color: $yellow;
  }
 
.question {
  display: block;
  width: 300px;
}

 .switch {
   margin: 5px 0;
 }

 .help-loader {
   text-align: center;
   width: 100%;
   padding: 5px;
   
   h2 {
     text-align: center!important;
     
   }

   .loading {
     font-size: 2rem;
   }
 }
</style>


// WEBPACK FOOTER //
// src/views/Offer/Help.vue